// extracted by mini-css-extract-plugin
export var footer = "_q2-5";
export var fulfillmentInput = "_q2-0";
export var shipDateInput = "_q2-1";
export var shipmentModal = "_q2-2";
export var shipmentModalContent = "_q2-3";
export var tableContainer = "_q2-4";